// RightNotesPanel.jsx (no Tailwind — inline styles)
import React, { useEffect, useState, useRef } from 'react';
import { X, Edit2 } from 'lucide-react';

export default function RightNotesPanel({ examConfig = {}, panelWidth = 360 }) {
  const storageKey = (() => {
    const id = examConfig?.testNumber ?? examConfig?.id ?? examConfig?.examId ?? 'global';
    return `exam_notes_test_${id}`;
  })();

  const [notes, setNotes] = useState('');
  const [savedFlash, setSavedFlash] = useState(false);

  // load notes
  useEffect(() => {
    try {
      const s = localStorage.getItem(storageKey) || '';
      setNotes(s);
    } catch (e) {
      setNotes('');
    }
  }, [storageKey]);

  // save notes & flash
  useEffect(() => {
    let t;
    try {
      localStorage.setItem(storageKey, notes);
      setSavedFlash(true);
      t = setTimeout(() => setSavedFlash(false), 900);
    } catch (e) {}
    return () => clearTimeout(t);
  }, [notes, storageKey]);

  const clearNotes = () => {
    setNotes('');
    try { localStorage.removeItem(storageKey); } catch (e) {}
  };

  // styles
  const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: panelWidth,
    alignSelf: 'start'          // ensure it aligns with navigator top
  },
  panelBox: {
    background: 'rgba(255,255,255,0.98)',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.06)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    // make it behave like navigator height (grow to content)
    height: 'fit-content',
    minHeight: 660
  },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 12px',
      background: 'linear-gradient(90deg,#5b21b6,#7c3aed)',
      color: 'white'
    },
    body: { padding: 12, flex: 1, display: 'flex', flexDirection: 'column' },
    textarea: {
      width: '100%',
      height: '100%',
      minHeight: 560,
      resize: 'none',
      padding: 10,
      borderRadius: 8,
      border: '1px solid rgba(0,0,0,0.08)',
      outline: 'none',
      //fontSize: 14,
      fontSize: 16,
                    fontFamily: `'JetBrains Mono', Consolas, 'Courier New', monospace`,
      color: '#111827'
    },
    footerSmall: { fontSize: 12, color: '#6b7280' },
    clearBtn: { fontSize: 13, background: 'transparent', border: 'none', color: 'white', cursor: 'pointer' }
  };

  return (
    <>
      {/* Desktop panel (rendered as grid column) */}
      <div style={styles.container} className="notes-column-desktop">
        <div style={styles.panelBox}>
          <div style={styles.header}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Edit2 size={18} color="rgba(255,255,255,0.95)" />
              <div style={{ fontWeight: 700, fontSize: 14 }}>My Notes</div>
              <div style={{ marginLeft: 6, fontSize: 12, color: 'rgba(255,255,255,0.9)' }}>({examConfig?.testNumber ?? 'global'})</div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.95)' }}>
                {savedFlash ? <span style={{ padding: '3px 8px', borderRadius: 9999, background: 'rgba(255,255,255,0.12)' }}>Saved</span> : <span style={{ opacity: 0.9 }}>Saved locally</span>}
              </div>
              <button onClick={clearNotes} style={styles.clearBtn} title="Clear notes">Clear</button>
            </div>
          </div>

          <div style={styles.body}>
            <textarea
              aria-label={`Exam notes ${storageKey}`}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Type quick notes for the exam here... (auto-saved per test)"
              style={styles.textarea}
            />
            <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={styles.footerSmall}>Tip: notes saved locally</div>
              <div style={{ fontSize: 12, color: '#6b7280' }}>{/* empty right */}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile inline notes (rendered below content by ExamInterface via media queries) */}
    </>
  );
}
